import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOmeMeetOrgUnitEntryPurchaseByIdData from './GetOmeMeetOrgUnitEntryPurchaseByIdData';
import getOmeMeetOrgUnitEntryPurchaseByOmeMeetOrgUnitEntryIdData from './GetOmeMeetOrgUnitEntryPurchaseByOmeMeetOrgUnitEntryIdData';
import postOmeMeetOrgUnitEntryPurchaseData from './PostOmeMeetOrgUnitEntryPurchaseData';
import deleteOmeMeetOrgUnitEntryPurchaseData from './DeleteOmeMeetOrgUnitEntryPurchaseData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const OmeMeetOrgUnitEntryPurchaseData = {
  INITIAL_STATE, getOmeMeetOrgUnitEntryPurchaseByOmeMeetOrgUnitEntryIdData, getOmeMeetOrgUnitEntryPurchaseByIdData,
  postOmeMeetOrgUnitEntryPurchaseData, deleteOmeMeetOrgUnitEntryPurchaseData
};

export default OmeMeetOrgUnitEntryPurchaseData;